import { render } from "./AnimalCardSimple.vue?vue&type=template&id=3bcdb996&scoped=true"
import script from "./AnimalCardSimple.vue?vue&type=script&lang=js"
export * from "./AnimalCardSimple.vue?vue&type=script&lang=js"

import "./AnimalCardSimple.vue?vue&type=style&index=0&id=3bcdb996&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcdb996"]])

export default __exports__